import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { MdOutlineEmail } from "react-icons/md";
import { SiWhatsapp } from "react-icons/si";
import { FaRegClock } from "react-icons/fa6";
import iconBag from '../../Assets/icon_bag.png'
import {
  FaInstagram,
  FaYoutube,
  FaFacebook
} from "react-icons/fa";
import * as S from './styles';

export const Contact = () => {
  const [sending, setSending] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const EMAIL_ENDPOINT = "https://functions-delivery.azurewebsites.net/api/enviar?code=DotNdS_84nOgt83pNs6Bwgz9u58tBx-GioQT_odEmKTMAzFua3IXag==";

  async function sendEmailReact({ name, email, phone, message }) {
    const payload = {
      de: "no-reply@bindflow.com.br",
      para: "contato@bindflow.com.br",
      assunto: "Contato pelo site Bindflow",
      corpo: `${name} <br />${email} <br />${phone} <br />${message}`
    };

    try {
      const response = await fetch(EMAIL_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });

      const text = await response.text();

      if (!response.ok) {
        throw new Error(text || "Falha ao enviar email");
      }

      return { ok: true };
    } catch (error) {
      return { ok: false, message: error.message };
    }
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setSending(true);

    const form = e.currentTarget;

    const name = form.name.value;
    const email = form.email.value;
    const phone = form.phone.value;
    const message = form.message.value;

    const result = await sendEmailReact({ name, email, phone, message });

    setSending(false);

    if (result.ok) {
      form.reset();
      alert("Mensagem enviada com sucesso!");
    } else {
      alert("Erro ao enviar: " + result.message);
    }
  }

  return (
    <S.Wrapper>
      <S.PageTitle>Contato</S.PageTitle>

      <S.ContentBox>
        <S.SideBox>
          <S.InfoList>
            <h3>Conecte-se</h3>
            <S.Socials size="lg">
              <a
                href="https://www.facebook.com/bindflow.io/?locale=pt_BR"
                aria-label="Facebook"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaFacebook size={27} />
              </a>

              <a
                href="https://www.youtube.com/channel/UCqE59qW4cFd7A7b5gGPbSvA"
                aria-label="YouTube"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaYoutube size={27} />
              </a>

              <a href="https://www.instagram.com/bindflow.io/"
                aria-label="Instagram"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram size={27} />
              </a>
            </S.Socials>
            <p><MdOutlineEmail size={24} />contato@bindflow.com.br</p>
            <p><SiWhatsapp size={24} />+55 41 98454-9244</p>
            <p><FaRegClock size={24} />Seg a Sex · 9h às 18h</p>
            <h3>Endereço</h3>
            <p>R. Comendador Roseira, 352<br />
              Curitiba, PR<br />
              80215-210
            </p>
          </S.InfoList>

          <S.SmallCtaDesk>
            <S.SmallCta
              onClick={() => navigate("/jobs")}
              tabIndex={0}
              role="button"
            >
              <img src={iconBag} alt='icon pasta' />

              <div>
                <h4>Quer fazer parte do nosso time?</h4>
                <p>Veja as vagas e os passos para aplicar agora mesmo.</p>
              </div>
            </S.SmallCta>
          </S.SmallCtaDesk>
        </S.SideBox>

        <S.Form onSubmit={handleSubmit} noValidate>
          <S.Field>
            <label htmlFor="name">Nome</label>
            <S.Input id="name" name="name" required />
          </S.Field>

          <S.Field>
            <label htmlFor="email">Email</label>
            <S.Input id="email" name="email" type="email" inputMode="email" required />
          </S.Field>

          <S.Field>
            <label htmlFor="phone">Telefone</label>
            <S.Input id="phone" name="phone" type="tel" inputMode="tel" />
          </S.Field>

          <S.Field>
            <label htmlFor="message">Mensagem</label>
            <S.Textarea id="message" name="message" rows={5} required />
          </S.Field>

          <S.ActionBtn type="submit" disabled={sending}>
            {sending ? "Enviando…" : "Enviar Mensagem"}
          </S.ActionBtn>
        </S.Form>

        <S.SmallCtaMobile>
          <S.SmallCta
            onClick={() => navigate("/jobs")}
            tabIndex={0}
            role="button"
          >
            <img src={iconBag} alt='icon pasta' />

            <div>
              <h4>Quer fazer parte do nosso time?</h4>
              <p>Veja as vagas e os passos para aplicar agora mesmo.</p>
            </div>
          </S.SmallCta>
        </S.SmallCtaMobile>
      </S.ContentBox>
    </S.Wrapper>
  );
};
